import React from "react";
import { Zap, Sparkles, GitBranch, Cpu, Mail, Instagram, MessageCircle } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
      <div className="chip chip-cyan mb-4"><Zap className="w-3 h-3" /> Founded Dec 2023</div>
      <h1 className="font-heading text-5xl font-black">Tentang <span className="gradient-text">NOXAI</span></h1>
      <p className="text-slate-300 mt-4 text-lg leading-relaxed">
        NOXAI CREATION lahir dari kecintaan pada kecerdasan buatan, aplikasi inovatif, dan seni virtual tanpa batas. Kolektif kreatif yang mengeksplorasi persimpangan teknologi &amp; imajinasi.
      </p>

      <div className="grid md:grid-cols-3 gap-6 mt-12">
        <div className="card p-6">
          <div className="w-10 h-10 rounded-lg bg-cyan1/10 border border-cyan1/30 flex items-center justify-center mb-4">
            <Sparkles className="w-5 h-5 text-cyan1" />
          </div>
          <h3 className="font-heading font-bold text-xl mb-2">AI-Powered</h3>
          <p className="text-slate-400 text-sm">Ringkasan otomatis via GPT-5, Claude Sonnet 4.6, dan Gemini 3.1 Pro.</p>
        </div>
        <div className="card p-6">
          <div className="w-10 h-10 rounded-lg bg-magenta1/10 border border-magenta1/30 flex items-center justify-center mb-4">
            <GitBranch className="w-5 h-5 text-magenta1" />
          </div>
          <h3 className="font-heading font-bold text-xl mb-2">Open Source</h3>
          <p className="text-slate-400 text-sm">Kurasi repo Llama, Claude, Ollama, LangChain, AutoGPT, dan MCP servers.</p>
        </div>
        <div className="card p-6">
          <div className="w-10 h-10 rounded-lg bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center mb-4">
            <Cpu className="w-5 h-5 text-emerald-400" />
          </div>
          <h3 className="font-heading font-bold text-xl mb-2">Deploy-Ready</h3>
          <p className="text-slate-400 text-sm">Full-stack FastAPI + React + MongoDB, siap di-deploy dalam satu klik.</p>
        </div>
      </div>

      <div className="mt-16">
        <h2 className="font-heading text-3xl font-bold mb-6">Filosofi Kami</h2>
        <p className="text-slate-300 leading-relaxed">
          Kami percaya teknologi harus memperkuat kreativitas manusia — bukan menggantikannya. Melalui NOXAI, kami menyajikan berita akurat, kurasi repository terbaik, dan alat siap-pakai agar developer &amp; kreator Indonesia dapat berpartisipasi dalam revolusi AI global.
        </p>
      </div>

      <div className="mt-16">
        <h2 className="font-heading text-3xl font-bold mb-6">Hubungi Kami</h2>
        <div className="flex flex-wrap gap-3">
          <a href="https://www.instagram.com/muse_nox/" target="_blank" rel="noreferrer" className="btn-ghost">
            <Instagram className="w-4 h-4" /> @muse_nox
          </a>
          <a href="https://discord.gg/t7VSFgpVE4" target="_blank" rel="noreferrer" className="btn-ghost">
            <MessageCircle className="w-4 h-4" /> Discord Community
          </a>
          <a href="mailto:noxaicreation@gmail.com" className="btn-primary">
            <Mail className="w-4 h-4" /> noxaicreation@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}
